import { useEffect, useState } from 'react';
import { diffParts } from '../lib/format.js';

export default function Countdown({ targetIso, label }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const { days, hours, minutes, seconds, isPast } = diffParts(targetIso, now);

  if (isPast) {
    return (
      <div className="card px-4 py-3">
        <p className="font-mono text-[10px] uppercase tracking-wider text-fg-tertiary">{label}</p>
        <p className="mt-0.5 text-lg font-medium">In progress</p>
      </div>
    );
  }

  return (
    <div className="card px-4 py-3">
      <p className="font-mono text-[10px] uppercase tracking-wider text-fg-tertiary">{label}</p>
      <div className="mt-1 flex items-baseline gap-3">
        <Cell value={days} unit="d" big />
        <Cell value={hours} unit="h" />
        <Cell value={minutes} unit="m" />
        <Cell value={seconds} unit="s" muted />
      </div>
    </div>
  );
}

function Cell({ value, unit, big = false, muted = false }) {
  return (
    <span className="flex items-baseline gap-0.5">
      <span
        className={[
          'tabular-nums',
          big ? 'text-3xl font-medium' : 'text-xl font-medium',
          muted ? 'text-fg-tertiary' : 'text-fg-primary',
        ].join(' ')}
      >
        {String(value).padStart(2, '0')}
      </span>
      <span className="font-mono text-xs text-fg-tertiary">{unit}</span>
    </span>
  );
}
